// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;

  const typeMap = {
    MIC_YEAR_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_YEAR_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastmic';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-innovative-companies',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: action.micYear,
        year: action.year,
        ads: adModelData
      };
    },
    MIC_YEAR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micYear.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
